import { useState } from 'react'
import { useLanguage } from '../../languages/language'
import { Link } from 'react-router-dom'
import {
  HeaderContainer,
  MenuDesktop,
  MenuMobile,
  MenuClose,
  MenuLanguage,
} from './styled'
import { MenuIcon } from '../../icons/menuicon'

const Header = () => {
  const { lang, setLang } = useLanguage()
  const { texts } = useLanguage()
  const [menu, setMenu] = useState(false)

  return (
    <HeaderContainer>
      {/*Link to="/">{texts.name}</Link>*/}
      <MenuDesktop>
        {texts &&
          texts.sections.map((section, index) => {
            return (
              <Link
                className="menu-desktop-item"
                to={'/' + section.url}
                key={`${section}-${index}`}
              >
                {section.name}
              </Link>
            )
          })}
      </MenuDesktop>
      <button title="menu" onClick={() => setMenu(!menu)}>
        <MenuIcon />
      </button>
      <MenuMobile $active={menu}>
        {texts.sections.map((section, index) => {
          return (
            <Link
              className="menu-desktop-item"
              to={'/' + section.url}
              key={`${section}-${index}`}
              onClick={() => setMenu(!menu)}
            >
              {section.name}
            </Link>
          )
        })}
        <MenuClose onClick={() => setMenu(!menu)}>
          <button>⨯</button>
        </MenuClose>
      </MenuMobile>
      <MenuLanguage onClick={() => setLang(lang === 'cz' ? 'en' : 'cz')}>
        {lang === 'cz' ? <>EN</> : <span>EN</span>}/
        {lang === 'en' ? <>CZ</> : <span>CZ</span>}
      </MenuLanguage>
    </HeaderContainer>
  )
}
export default Header
